"use client";

import { type ErrorPageProps, ServerErrorContent } from "@tosize/ui";
import { useEffect } from "react";
import { logError } from "~/lib/logError";
import { lato } from "~/styles/font";

export default function GlobalErrorPage(props: ErrorPageProps) {
	useEffect(() => {
		logError({
			error: props.error,
			digest: props.error.digest,
			tags: { group: "global" },
		});
	}, [props.error]);

	return (
		<html lang="en" className={lato.variable}>
			<body>
				<ServerErrorContent {...props} />
			</body>
		</html>
	);
}
